module.exports = __webpack_public_path__ + "img/0bcc044.png";